export default "__VITE_ASSET__BPJA60eV__"